module.exports = __webpack_public_path__ + "static/media/asuper.94afb994.mp4";